(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function init(root) {
    if (!root || root.getAttribute('data-ss-ready') === 'true') return;

    var stage = root.querySelector('[data-ss-stage]');
    var track = root.querySelector('[data-ss-track]');
    var slides = toArray(root.querySelectorAll('[data-ss-slide]'));
    var dotsWrap = root.querySelector('[data-ss-dots]');
    var prev = root.querySelector('[data-ss-prev]');
    var next = root.querySelector('[data-ss-next]');
    var status = root.querySelector('[data-ss-status]');
    if (!track || slides.length === 0) return;

    root.setAttribute('data-ss-ready', 'true');

    var delay = parseInt(root.getAttribute('data-interval'), 10) || 7000;
    var designMode = window.Shopify && window.Shopify.designMode;
    var autoplaySetting = root.getAttribute('data-autoplay') === 'true';
    var index = 0;
    var timer = null;
    var hovering = false;
    var hidden = document.hidden;
    var dots = [];
    var wheelLock = false;
    var touchStartY = 0;
    var touchStartX = 0;
    var touchActive = false;
    var touchLocked = false;
    var touchMoved = false;

    function maxIndex() {
      return Math.max(0, slides.length - 1);
    }

    function atStart() {
      return index <= 0;
    }

    function atEnd() {
      return index >= maxIndex();
    }

    /**
     * On first/last slide, disable nested scrolling so a finger on the image
     * can scroll the page instead of feeling stuck inside the track.
     */
    function syncEdgeScroll() {
      var edge = atStart() || atEnd() || maxIndex() === 0;
      root.classList.toggle('ss--at-edge', edge);
      root.classList.toggle('ss--at-start', atStart());
      root.classList.toggle('ss--at-end', atEnd());
      if (edge) {
        track.style.overflowY = 'hidden';
      } else {
        track.style.overflowY = '';
      }
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      if (slides.length <= 1) return;
      for (var i = 0; i < slides.length; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ss__dot' + (i === index ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Show story image ' + (i + 1));
        btn.setAttribute('aria-current', i === index ? 'true' : 'false');
        (function (page) {
          btn.addEventListener('click', function () {
            go(page);
          });
        })(i);
        dotsWrap.appendChild(btn);
        dots.push(btn);
      }
    }

    function updateDots() {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (status) {
        status.textContent = (index + 1) + ' / ' + slides.length;
      }
      root.setAttribute('data-ss-at-start', atStart() ? 'true' : 'false');
      root.setAttribute('data-ss-at-end', atEnd() ? 'true' : 'false');
      syncEdgeScroll();
    }

    function syncStageHeight(slideEl) {
      if (!stage) return;
      var slide = slideEl || slides[index];
      var img = slide && slide.querySelector('.ss__img');
      if (!img) return;

      function apply() {
        var nw = img.naturalWidth;
        var nh = img.naturalHeight;
        var w = stage.clientWidth;
        if (!nw || !nh || !w) return;
        var h = Math.max(1, Math.round(w * (nh / nw)));
        stage.style.setProperty('--ss-fit-h', h + 'px');
      }

      if (img.complete && img.naturalWidth) {
        apply();
      } else {
        img.addEventListener('load', apply, { once: true });
      }
    }

    function go(target, instant) {
      index = Math.max(0, Math.min(target, maxIndex()));
      var slide = slides[index];
      syncStageHeight(slide);
      window.requestAnimationFrame(function () {
        if (slide) {
          track.scrollTo({
            top: slide.offsetTop,
            behavior: instant || reduceMotion ? 'auto' : 'smooth'
          });
        }
        updateDots();
        restartTimer();
      });
    }

    function nextSlide(wrap) {
      if (atEnd()) {
        if (wrap) go(0);
        return false;
      }
      go(index + 1);
      return true;
    }

    function prevSlide(wrap) {
      if (atStart()) {
        if (wrap) go(maxIndex());
        return false;
      }
      go(index - 1);
      return true;
    }

    function stopTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startTimer() {
      stopTimer();
      if (!autoplaySetting || designMode || reduceMotion || hovering || hidden || maxIndex() === 0) return;
      timer = setInterval(function () {
        nextSlide(true);
      }, delay);
    }

    function restartTimer() {
      stopTimer();
      startTimer();
    }

    function passScrollToPage(deltaY) {
      window.scrollBy({ top: deltaY, left: 0, behavior: 'auto' });
    }

    function onWheel(event) {
      if (maxIndex() === 0) return;
      if (Math.abs(event.deltaY) < 4) return;

      var scrollingDown = event.deltaY > 0;
      var release = (atStart() && !scrollingDown) || (atEnd() && scrollingDown);

      // First/last slide: release to page scroll so user never gets stuck
      if (release) {
        event.preventDefault();
        passScrollToPage(event.deltaY);
        return;
      }

      event.preventDefault();
      if (wheelLock) return;
      wheelLock = true;

      if (scrollingDown) nextSlide(false);
      else prevSlide(false);

      window.setTimeout(function () {
        wheelLock = false;
      }, reduceMotion ? 120 : 480);
    }

    function onTouchStart(event) {
      if (!event.touches || event.touches.length !== 1) return;
      touchStartY = event.touches[0].clientY;
      touchStartX = event.touches[0].clientX;
      touchActive = true;
      touchLocked = false;
      touchMoved = false;
    }

    function onTouchMove(event) {
      if (!touchActive || !event.touches || event.touches.length !== 1) return;

      var y = event.touches[0].clientY;
      var x = event.touches[0].clientX;
      var dy = touchStartY - y; // + finger moved up → want next / page down
      var dx = touchStartX - x;

      if (!touchMoved && Math.abs(dy) < 8 && Math.abs(dx) < 8) return;
      touchMoved = true;

      // Mostly horizontal — leave alone
      if (Math.abs(dx) > Math.abs(dy)) return;

      // At edges: never capture the gesture — let the page scroll
      if (atEnd() && dy > 0) return;
      if (atStart() && dy < 0) return;
      if (maxIndex() === 0) return;

      // Middle slides (or reversing from an edge): keep swipe inside the slider
      touchLocked = true;
      if (event.cancelable) event.preventDefault();
    }

    function onTouchEnd(event) {
      if (!touchActive) return;
      touchActive = false;

      var t = event.changedTouches && event.changedTouches[0];
      if (!t || !touchMoved) return;

      var dy = touchStartY - t.clientY;
      var dx = touchStartX - t.clientX;
      var threshold = 48;

      if (Math.abs(dy) < threshold || Math.abs(dy) < Math.abs(dx) * 1.15) return;

      // Swipe up → next; swipe down → previous. Ignore when leaving the section.
      if (dy > 0) {
        if (atEnd()) return;
        nextSlide(false);
      } else {
        if (atStart()) return;
        prevSlide(false);
      }
    }

    function onTouchCancel() {
      touchActive = false;
      touchLocked = false;
      touchMoved = false;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        prevSlide(false);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        nextSlide(false);
      });
    }

    root.addEventListener('mouseenter', function () {
      hovering = true;
      stopTimer();
    });
    root.addEventListener('mouseleave', function () {
      hovering = false;
      startTimer();
    });

    document.addEventListener('visibilitychange', function () {
      hidden = document.hidden;
      if (hidden) stopTimer();
      else startTimer();
    });

    window.addEventListener('resize', function () {
      go(index, true);
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        var nearest = 0;
        var nearestDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetTop - track.scrollTop);
          if (dist < nearestDist) {
            nearestDist = dist;
            nearest = i;
          }
        });
        if (nearest !== index) {
          index = nearest;
          syncStageHeight(slides[index]);
          updateDots();
        }
      });
    }, { passive: true });

    var gestureTarget = stage || track;
    gestureTarget.addEventListener('wheel', onWheel, { passive: false });
    gestureTarget.addEventListener('touchstart', onTouchStart, { passive: true });
    gestureTarget.addEventListener('touchmove', onTouchMove, { passive: false });
    gestureTarget.addEventListener('touchend', onTouchEnd, { passive: true });
    gestureTarget.addEventListener('touchcancel', onTouchCancel, { passive: true });

    slides.forEach(function (slide) {
      var img = slide.querySelector('.ss__img');
      if (img && !img.complete) {
        img.addEventListener('load', function () {
          if (slide === slides[index]) syncStageHeight(slide);
        });
      }
    });

    buildDots();
    syncStageHeight(slides[0]);
    go(0, true);
    startTimer();
  }

  function boot() {
    toArray(document.querySelectorAll('[data-ss]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    toArray(event.target.querySelectorAll('[data-ss]')).forEach(function (el) {
      el.removeAttribute('data-ss-ready');
      init(el);
    });
  });
})();
